import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function zipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const zipCodePattern = /^\d{5}(\d{4})?$/;// Matches 5 or 9 digit ZIP codes
    const isValid = zipCodePattern.test(control.value);
    return isValid ? null : { invalidZipCode: true };
  };
}
